import { Platform } from 'react-native';
import styled from 'styled-components/native';

export default styled.View`
  padding: ${Platform.OS === 'web' ? '0 0 40px' : '25px 0'};
  margin: ${Platform.OS === 'web' ? '0 0 25px' : '0'};
  border-bottom-width: 1px;
  border-bottom-color: ${({ theme }) => theme.orderDetailsHeader.border};
`;
